/* Maison Thaevia — Tier Highlights carousel
   Three-copy infinite loop: tiles are rendered ×3 in Liquid.
   Starts at the middle copy; after each slide, silently re-centres
   so the carousel wraps endlessly in both directions.
   Matches the Tiers component logic in Homepage.jsx exactly. */

if (!customElements.get('mt-tier-carousel')) {
  class MTTierCarousel extends HTMLElement {
    connectedCallback() {
      this._track     = this.querySelector('.mt-tiers__track');
      this._prev      = this.querySelector('.mt-tiers__arrow--prev');
      this._next      = this.querySelector('.mt-tiers__arrow--next');
      this._indicator = this.querySelector('.mt-tiers__indicator');
      this._count     = parseInt(this.dataset.tileCount, 10) || 6;
      this._timer     = null;

      if (!this._track) return;

      this._prev?.addEventListener('click', () => this._slide(-1));
      this._next?.addEventListener('click', () => this._slide(1));
      this._track.addEventListener('scroll', () => this._onScroll(), { passive: true });

      /* Position at the start of the middle copy once tiles have layout */
      requestAnimationFrame(() => {
        this._track.scrollLeft = this._copyW();
        this._onScroll();
      });
      /* Belt-and-braces fallback for slow paints */
      setTimeout(() => {
        if (this._track.scrollLeft === 0) {
          this._track.scrollLeft = this._copyW();
          this._onScroll();
        }
      }, 300);
    }

    /* Width of one tile step (tile + gap) */
    _stepW() {
      const first = this._track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 24 : 0;
    }

    /* Width of one full copy of all tiles */
    _copyW() {
      return this._stepW() * this._count;
    }

    /* Silently jump back into the middle copy if we drift into copy 1 or 3 */
    _normalize() {
      const cw = this._copyW();
      if (!cw) return;
      if (this._track.scrollLeft < cw * 0.5) {
        this._track.scrollLeft += cw;
      } else if (this._track.scrollLeft >= cw * 1.5) {
        this._track.scrollLeft -= cw;
      }
    }

    /* Update the bronze progress indicator */
    _onScroll() {
      const cw = this._copyW();
      if (!cw || !this._indicator) return;
      const sl    = this._track.scrollLeft;
      const prog  = ((sl % cw) + cw) % cw / cw;
      this._indicator.style.left = `${Math.round(prog * 67)}%`;
    }

    _slide(dir) {
      this._normalize();
      this._track.scrollBy({ left: dir * this._stepW(), behavior: 'smooth' });
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this._normalize(), 480);
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
    }
  }

  customElements.define('mt-tier-carousel', MTTierCarousel);
}
